<template>
  <nav class="ai-visibility-detail-tabs" aria-label="AI Visibility detail tabs">
    <template v-if="embedded">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="ai-visibility-detail-tabs__link"
        :class="{ 'ai-visibility-detail-tabs__link--active': tab.routeName === activeRouteName }"
        @click="$emit('select-tab', tab)"
      >
        {{ tab.label }}
      </button>
    </template>
    <template v-else>
      <router-link
        v-for="tab in tabs"
        :key="tab.key"
        class="ai-visibility-detail-tabs__link"
        :class="{ 'ai-visibility-detail-tabs__link--active': tab.routeName === activeRouteName }"
        :to="{ name: tab.routeName, params: { siteId, trackerId } }"
      >
        {{ tab.label }}
      </router-link>
    </template>
  </nav>
</template>

<script>
export default {
  name: 'DetailTabNav',
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    siteId: {
      type: [Number, String],
      required: true,
    },
    trackerId: {
      type: [Number, String],
      required: true,
    },
    activeRouteName: {
      type: String,
      required: true,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-detail-tabs {
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid var(--v-gray13Color-base);
  gap: 30px;
  margin-top: 24px;
}

.ai-visibility-detail-tabs__link {
  border-bottom: 2px solid transparent;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  background: transparent;
  color: var(--v-mainColor3-base);
  cursor: pointer;
  flex: 0 0 auto;
  font-size: 16px;
  font-weight: 500;
  padding: 0 0 13px;
  text-decoration: none;
}

.ai-visibility-detail-tabs__link--active {
  border-bottom-color: var(--v-profileAnchorColor-base);
  color: var(--v-profileAnchorColor-base);
  font-weight: 700;
}
</style>
